export default __webpack_public_path__ + "162984fcb0da618f2ee7907c3e0c9966.jpg";